import { generateCrud } from './helpers'

export default function (dbId) {
  const path = dbId ? `/api/groups/${dbId}` : '/api/groups'
  const crud = generateCrud(path)

  return {
    create: crud.create,
    read: crud.read,
    update: crud.update,
    convertToSurvey: generateCrud(`${path}/convert_to_survey`).create
  }
}
